import styles from './Workplaces.module.css';
import Button from '../../../components/Button/Button';
import Input from '../../../components/Input/Input';
import {CustomSelect} from '../../../components/Select/Select';
import {
	getAllDivisionsUrl,
	getAllProfessionsUrl,
	getAllWorkplacesUrl
} from '../../../helpers/constants';
import React, {useEffect, useState} from 'react';
import UniversalTable from '../../../components/UTable/UTable';
import {Modal} from '../../../components/Modals/Modal';
import useFillSelect from '../../../hooks/useFillSelect.hook';
import {ManageActivities} from '../../../components/Modals/ManageActivities/ManageActivities';
import {ManageCompensations} from '../../../components/Modals/ManageCompensations/ManageCompensations';
import {CreateWorkplace} from '../../../components/Modals/CreateWorkplace/CreateWorkplace';
import {BindWorkplace} from '../../../components/Modals/BindWorkplace/BindWorkplace';
import {DeleteWorkplace} from '../../../components/Modals/DeleteWorkplace/DeleteWorkplace';
import {UploadSout} from '../../../components/Modals/UploadSout/UploadSout';
import ErrorMessage from '../../../components/ErrorMessage/ErrorMessage';
import {getColumns} from './table_columns';
import {SurfaceBar} from '../../../components/SurfaceBar/SurfaceBar';


export function Workplaces () {
	const [selectedProfOption, setSelectedProfOption] = useState(null);
	const [selectedDivOption, setSelectedDivOption] = useState(null);
	const [positionFilter, setPositionFilter] = useState(undefined);
	const [isCreateModalOpen, setCreateModalOpen] = useState(false);
	const [isManageActivitiesModalOpen, setManageActivitiesModalOpen] = useState(false);
	const [isManageCompensationsModalOpen, setManageCompensationsModalOpen] = useState(false);
	const [isUploadSoutModalOpen, setUploadSoutModalOpen] = useState(false);
	const [bindWorkplace, setBindWorkplace] = useState(null);
	const [selectedWorkplace, setSelectedWorkplace] = useState(null);
	const [deleteWorkplace, setDeleteWorkplace] = useState(null);
	const [totalRecords, setTotalRecords] = useState(0);
	const [refreshKey, setRefreshKey] = useState(0);
	const [errorApi, setErrorApi] = useState(undefined);

	const {
		error: errorProf,
		options: optionsProf
	} = useFillSelect({
		endpoint: getAllProfessionsUrl,
		labelField: 'title'
	});

	const {
		error: errorDiv,
		options: optionsDiv
	} = useFillSelect({
		endpoint: getAllDivisionsUrl,
		labelField: 'title'
	});

	useEffect(() => {
		setErrorApi(errorProf || errorDiv);
	}, [errorProf, errorDiv]);

	const ClearFilters = () => {
		setSelectedProfOption(null);
		setSelectedDivOption(null);
		setPositionFilter('');
	};

	const [debouncedPosition, setDebouncedPosition] = useState(positionFilter);

	useEffect(() => {
		const timer = setTimeout(() => {
			setDebouncedPosition(positionFilter);
		}, 500);

		return () => clearTimeout(timer);
	}, [positionFilter]);


	let filters = {};
	if (positionFilter) {
		filters = {
			...filters,
			position__ilike: `%${debouncedPosition}%`
		};
	}
	if (selectedProfOption) {
		filters = {
			...filters,
			profession_id__in: selectedProfOption.value
		};
	}
	if (selectedDivOption) {
		filters = {
			...filters,
			division_id__in: selectedDivOption.value
		};
	}

	const openEditModal = (workplace) => {
		setSelectedWorkplace(workplace);
		setCreateModalOpen(true);
	};

	const closeCreateModal = () => {
		setCreateModalOpen(false);
		setSelectedWorkplace(null);
	};

	const columns = getColumns(
		setBindWorkplace, openEditModal, setDeleteWorkplace, styles
	);

	const managementActions = (
		<>
			<Button onClick={() => openEditModal(null)}>
				Добавить рабочее место
			</Button>
			<Modal isOpen={isCreateModalOpen} onClose={closeCreateModal}>
				<CreateWorkplace
					key={selectedWorkplace?.id ?? 'new'}
					optionsProf={optionsProf}
					optionsDiv={optionsDiv}
					setCreateModalOpen={closeCreateModal}
					setRefreshKey={setRefreshKey}
					currentWorkplace={selectedWorkplace}
				/>
			</Modal>
			<Button onClick={() => setUploadSoutModalOpen(true)}>
				Загрузить СОУТ
			</Button>
			<Modal isOpen={isUploadSoutModalOpen} onClose={() => setUploadSoutModalOpen(false)}>
				<UploadSout
					setModalOpen={setUploadSoutModalOpen}
					setRefreshKey={setRefreshKey}
				/>
			</Modal>
			<Button onClick={() => setManageActivitiesModalOpen(true)}>
				Опасные факторы
			</Button>
			<Modal isOpen={isManageActivitiesModalOpen} onClose={() => setManageActivitiesModalOpen(false)}>
				<ManageActivities />
			</Modal>
			<Button onClick={() => setManageCompensationsModalOpen(true)}>
				Компенсации
			</Button>
			<Modal
				isOpen={isManageCompensationsModalOpen}
				onClose={() => setManageCompensationsModalOpen(false)}
			>
				<ManageCompensations />
			</Modal>
		</>
	);

	return (
		<div className={styles.workplaces}>
			<SurfaceBar actions={managementActions} />

			<div className={styles.outer_table}>
				<h2 className={styles.section_title}>Рабочие места</h2>
				<ErrorMessage
					error={errorApi}
					onClose={() => setErrorApi(undefined)}
				/>
				<div className={styles.table_toolbar}>
					<div className={styles.filters_table}>
						<Input
							value={positionFilter}
							onChange={(e) => setPositionFilter(e.target.value)}
							placeholder="Поиск по должности"
						/>
						<CustomSelect
							value={selectedProfOption}
							options={optionsProf}
							placeholder="Профессия"
							onChange={setSelectedProfOption}
						>
						</CustomSelect>
						<CustomSelect
							value={selectedDivOption}
							options={optionsDiv}
							placeholder="Подразделение"
							onChange={setSelectedDivOption}
						>
						</CustomSelect>
						<buton className={styles.filter_button} onClick={ClearFilters}>
							<img src="/icons/drop-filters-icon.svg" alt="drop-filters"/>
						</buton>
					</div>
					<div className={styles.table_count}>
						Записей: {totalRecords}
					</div>
				</div>
				<div className={styles.table}>
					<UniversalTable
						endpoint={getAllWorkplacesUrl}
						columns={columns}
						usePagination={false}
						filters={filters}
						onTotalRecordsChange={setTotalRecords}
						refreshKey={refreshKey}
					/>
				</div>
				<Modal
					isOpen={!!bindWorkplace}
					onClose={() => setBindWorkplace(null)}
					wide
				>
					{bindWorkplace && (
						<BindWorkplace
							key={bindWorkplace.id}
							workplace={bindWorkplace}
							setRefreshKey={setRefreshKey}
						/>
					)}
				</Modal>
				<Modal
					isOpen={!!deleteWorkplace}
					onClose={() => setDeleteWorkplace(null)}
				>
					{deleteWorkplace && (
						<DeleteWorkplace
							workplace={deleteWorkplace}
							setDeleteModalOpen={() => setDeleteWorkplace(null)}
							setRefreshKey={setRefreshKey}
						/>
					)}
				</Modal>
			</div>
		</div>
	);
}